import Vue from 'vue';
import Vuex from 'vuex';

import feedback from './modules/feedback';
import payment from './modules/payment';
import personal from './modules/personal';
import photo from './modules/photo';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // state
  },
  getters: {
    // getters
  },
  mutations: {
    // mutations
  },
  actions: {
    clearSession({ dispatch }) {
      dispatch('feedback/clearAll');
      dispatch('payment/clearAll');
      dispatch('personal/clearAll');
      dispatch('photo/clearAll');
    },
  },
  modules: {
    feedback,
    payment,
    personal,
    photo,
  },
  plugins: [],
});
